import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  header: {
    display: 'inline-block',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    textAlign: 'center',
  },
  mainHeader: {
    float: 'left',
    fontSize: '24px',
    fontWeight: 800,
    lineHeight: '28px',
    textAlign: 'center',
  },
  secondHeader: {
    marginRight: '14px',
    float: 'right',
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 400,
    textAlign: 'center',
  },
  spanHeader: {
    fontWeight: 800,
  },
  grayContainer: {
    borderRadius: '5px',
    background: '#EBECF4',
    width: '100%',
    height: '100%',
    marginBottom: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
  },
  text: {
    textAlign: 'center',
    color: '#3C419A',
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '24px',
    margin: '50px',
  },
  singleButton: {
    background: '#3C419A',
    '&:hover, &:focus': {
      backgroundColor: '#2C307D',
    },
    '&:disabled': {
      color: 'white',
      backgroundColor: '#6F707B',
    },
    width: '214px',
  },
  groupButton: {
    background: '#3560FF',
    '&:hover, &:focus': {
      backgroundColor: '#2346C6',
    },
    '&:disabled': {
      color: 'white',
      backgroundColor: '#6F707B',
    },
    width: '278px',
  },
  subContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '600px',
  },

  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    '& button': {
      margin: '5px',
      color: '#FFFFFF',
      fontWeight: 500,
      fontSize: '15px',
      lineHeight: '28px',
    },
  },
}));
